import { jsx as _jsx } from "react/jsx-runtime";
import AppRoute from './routes/AppRouter';
import './index.css';
//react functional returns the whole app along with routes.
const App = () => {
    return _jsx(AppRoute, {});
};
export default App;
